import translate from '@translate';
import React, { FC } from 'react';
import DateTimePicker from 'src/components/DateTimePicker';
import Grid, { GridItem } from 'src/components/Grid';
import Select from 'src/components/Select';
import TextField from 'src/components/TextField';
import Typography from 'src/components/Typography';
import Tooltip from '../../components/Tooltip';
import { InfoIcon } from '../../components/SkladonIcon/Icons';
import { styled } from '@mui/material/styles';
import { ReceivingType } from 'src/types/receiving';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface DetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: ReceivingType;
    editErrors: FormErrorsType;
    disableEdit: boolean;
    driverCompanyCodes: ConstantsCodeType[];
    newReceiving: boolean;
}

const InfoIconStyled = styled('span')({
    marginLeft: '10px',

    '& svg': {
        width: '14px',
        height: '14px',
        marginRight: '10px'
    }
});

const Driver: FC<DetailPropsType> = (props) => {
    return (
        <Grid>
            <GridItem cols={12}>
                <Typography variant="h2">{translate('receivingDetail.driver')}</Typography>
            </GridItem>
            <GridItem cols={12}>
                <Select
                    options={props.driverCompanyCodes}
                    value={props.editData.DRIVER_COMPANY}
                    error={props.editErrors.DRIVER_COMPANY}
                    onChange={(value, error) => props.onChange('DRIVER_COMPANY', value, error)}
                    name="DRIVER_COMPANY"
                    label={translate('receivingDetail.driverCompany')}
                    fullWidth
                    required
                    disabled={props.disableEdit}
                />
            </GridItem>
            {props.editData.DRIVER_COMPANY === 'other' && (
                <GridItem cols={12}>
                    <TextField
                        value={props.editData.DRIVER_COMPANY_OTHER_NAME}
                        error={props.editErrors.DRIVER_COMPANY_OTHER_NAME}
                        onChange={(value, error) => props.onChange('DRIVER_COMPANY_OTHER_NAME', value, error)}
                        name="DRIVER_COMPANY_OTHER_NAME"
                        label={translate('receivingDetail.driverCompanyOtherName')}
                        fullWidth
                        maxLength={255}
                        disabled={props.disableEdit}
                        required={props.editData.DRIVER_COMPANY === 'other'}
                    />
                </GridItem>
            )}
            <GridItem cols={12}>
                <TextField
                    value={props.editData.TRACKING_NUMBER}
                    error={props.editErrors.TRACKING_NUMBER}
                    onChange={(value, error) => props.onChange('TRACKING_NUMBER', value, error)}
                    name="TRACKING_NUMBER"
                    label={<>
                        {translate('receivingDetail.trackingNumber')}
                        <Tooltip title={translate('receivingDetail.trackingNumberTooltip')}>
                            <InfoIconStyled>
                                <InfoIcon />
                            </InfoIconStyled>
                        </Tooltip>
                    </>}
                    fullWidth
                    required
                    maxLength={255}
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={12}>
                <DateTimePicker
                    value={props.editData.ESTIMATED_DELIVERY}
                    error={props.editErrors.ESTIMATED_DELIVERY}
                    onChange={(value, error) => props.onChange('ESTIMATED_DELIVERY', value, error)}
                    name="ESTIMATED_DELIVERY"
                    label={<>
                        {translate('receivingDetail.estimatedDelivery')}
                        <Tooltip title={translate('receivingDetail.estimatedDeliveryTooltip')}>
                            <InfoIconStyled>
                                <InfoIcon />
                            </InfoIconStyled>
                        </Tooltip>
                    </>}
                    fullWidth
                    // format={'lll'}
                    disabled={props.disableEdit}
                    disablePast
                    required
                    type="dateTime"
                />
            </GridItem>
            {!props.newReceiving && props.editData.STATUS !== 'awaiting' && (
                <GridItem cols={12}>
                    <DateTimePicker
                        value={props.editData.REAL_DELIVERY}
                        name="REAL_DELIVERY"
                        label={translate('receivingDetail.realDelivery')}
                        fullWidth
                        disabled
                        type="dateTime"
                    />
                </GridItem>
            )}
            <GridItem cols={12}>
                <TextField
                    value={props.editData.DRIVER_NAME}
                    error={props.editErrors.DRIVER_NAME}
                    onChange={(value, error) => props.onChange('DRIVER_NAME', value, error)}
                    name="DRIVER_NAME"
                    label={translate('receivingDetail.driverName')}
                    fullWidth
                    maxLength={200}
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.DRIVER_PHONE}
                    error={props.editErrors.DRIVER_PHONE}
                    onChange={(value, error) => props.onChange('DRIVER_PHONE', value, error)}
                    name="DRIVER_PHONE"
                    label={translate('receivingDetail.driverPhone')}
                    fullWidth
                    maxLength={18}
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.DRIVER_DISPATCHER_CONTACT}
                    error={props.editErrors.DRIVER_DISPATCHER_CONTACT}
                    onChange={(value, error) => props.onChange('DRIVER_DISPATCHER_CONTACT', value, error)}
                    name="DRIVER_DISPATCHER_CONTACT"
                    label={translate('receivingDetail.dispatcherContact')}
                    fullWidth
                    maxLength={200}
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.DRIVER_TRAILER_LICENSE_PLATE}
                    error={props.editErrors.DRIVER_TRAILER_LICENSE_PLATE}
                    onChange={(value, error) => props.onChange('DRIVER_TRAILER_LICENSE_PLATE', value, error)}
                    name="DRIVER_TRAILER_LICENSE_PLATE"
                    label={translate('receivingDetail.driverTrailerLicensePlate')}
                    fullWidth
                    maxLength={20}
                    disabled={props.disableEdit}
                />
            </GridItem>
        </Grid>
    );
};

export default Driver;
